module.exports = __webpack_public_path__ + "img/maria.ba58f48c.jpg";